export default __webpack_public_path__ + "static/emerald-crystal-2f718fc2b4aaa94778d0db674cd4fa39.png";